import React, { useEffect, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader.js";
import {getLastSession,getCurrentDeviceSerial,setCurrentDeviceSerial} from '../../Data/SessionData.js';
import { createSession, loginUser, getAlertsData, updateAlertsData } from '../../RestUtil.js';
import { baseURL } from '../../RestUtil.js';
import { Link } from "react-router-dom";

export default function MyAlerts() {

  const [showMode, setShowMode] = useState("Alerts");
  const [alertsData, setAlertsData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(0);
  const [totalHits, setTotalHits] = useState(0);
  const [currDeviceSerial, setCurrDeviceSerial] = useState(getCurrentDeviceSerial);

  useEffect(() => {
    pullAlertsData("Alert");
  }, []);

  useEffect(() => {
    console.log("Now showMode changed as ",showMode);
    if (showMode === 'Alerts')
       pullAlertsData("Alert");
    else
    if (showMode === 'Images')
       pullAlertsData("Image");
    else
       pullAlertsData("Warning");
  }, [showMode]);

  const deviceSerialChanged = (newSerial) => {
    console.log("Device Serial changed detected4 in MyAlerts",newSerial);
    setCurrentDeviceSerial(newSerial);
    setCurrDeviceSerial(newSerial);
    pullAlertsData("Alert",newSerial);
  }

  const handleViewClicked = (idStr) => {
     console.log("I am here at View",idStr);
     var sessionData = getLastSession();
     var alertType = (showMode === 'Alerts')?'Alert':(showMode === 'Images'?'Image':'Warning');
     updateAlertsData(sessionData.id,currDeviceSerial,alertType,'Viewed',idStr).then(resp => {
      console.log("updateAlertsData resp",resp);
      setAlertsData(resp);
      updatePageCount(resp);
    })
    .catch(err2 => {
      console.log("updateAlertsData failed",err2);          
    });
  }

  {/*
  const handleDeleteClicked = (idStr) => {
    console.log("I am here at Delete",idStr);
    var sessionData = getLastSession();
    var alertType = (showMode === 'Alerts')?'Alert':'Warning';
    updateAlertsData(sessionData.id,currDeviceSerial,alertType,'Deleted',idStr).then(resp => {
      console.log("updateAlertsData resp",resp);
      setAlertsData(resp);
    })
    .catch(err2 => {
      console.log("updateAlertsData failed",err2);          
    });
  }
  */}

  function handleShowModeChange(newMode) {
    setShowMode(newMode);
  }

  function updatePageCount(resp) {
    setRowsPerPage(resp.length);
    if (resp.length > 0) {
      let firstRow = resp[0];
        if (firstRow != null) {
           setTotalHits(firstRow.totalCount);
        }
    }
}

  function pullAlertsData(alertType,newSerial) {
    var sessionData = getLastSession();
    if (newSerial) {
        console.log("now pulling alerts data for serial",newSerial);
        getAlertsData(sessionData.id,newSerial,alertType,0,10).then(resp => {
          console.log("getAlertsData1 resp",resp);
          setAlertsData(resp);
          updatePageCount(resp);
        })
        .catch(err2 => {
          console.log("getAlertsData failed",err2);          
        });
    }
    else {
        console.log("now pulling alerts data for serial",currDeviceSerial);
        getAlertsData(sessionData.id,currDeviceSerial,alertType,0,10).then(resp => {
          console.log("getAlertsData3 resp",resp);
          setAlertsData(resp);
          updatePageCount(resp);
        })
        .catch(err2 => {
          console.log("getAlertsData failed",err2);          
        });
    }
  }

  return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="My Alerts"
              Breadcrumb={[
                { name: "Home", navigate: "" },
                { name: "My Alerts", navigate: "" },
              ]}
              LastUpdatedDate={new Date().toLocaleString()} 
              deviceSerial={currDeviceSerial}
              callback={deviceSerialChanged}
            />
<div className="col-lg-12">
        <div className="card product_item_list product-order-list">
          <div className="header d-flex justify-content-between">
            <h2>List of Alerts & Warnings</h2>
            <div style={{verticalAlign: "center"}}>
               <h6>Showing {rowsPerPage} of {totalHits}</h6>
            </div>
            <div style={{display:"flex",gap:"10px"}}>
              <button className={`btn ${showMode === "Images" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleShowModeChange('Images')} type="button">Images</button>
              <button className={`btn ${showMode === "Alerts" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleShowModeChange('Alerts')} type="button">Alerts</button>
              <button className={`btn ${showMode === "Warnings" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleShowModeChange('Warnings')} type="button">Warnings</button>
            </div>
          </div>
          <div className="body">
            <div className="table-responsive">
              <table className="table table-hover m-b-0">
                <thead className="thead-dark">
                  <tr>
                    <th>Date/Time</th>
                    {showMode === 'Images' ? (
                      <>
                        <th>Image</th>
                        <th>OCR Text</th>
                      </>
                    ) : (
                      <>
                        <th>Alert Message</th>
                        <th>Param Key</th>
                        <th>Param Value</th>
                        <th data-breakpoints="xs md">Type</th>
                        <th data-breakpoints="sm xs md">Action</th>
                      </>
                    )}
                  </tr>
                </thead>
                {alertsData && 
                <tbody>
                    {alertsData && alertsData.map((data, index) => {
                      return (              
                  <tr>
                    <td>{data.dateTime}</td>
                    {showMode === 'Images' ? (
                      <>
                        <td>
                          <img 
                            src={`${baseURL}/images/${encodeURIComponent(data.alertMessage)}`}
                            alt="Alert Image" 
                            style={{ 
                              maxWidth: '100px', 
                              maxHeight: '100px', 
                              cursor: 'pointer' 
                            }}
                            onClick={() => window.open(`${baseURL}/images/${encodeURIComponent(data.alertMessage)}`, '_blank')}
                          />
                        </td>
                        <td>{data.param.value}</td>
                      </>
                    ) : (
                      <>
                    <td>{data.alertMessage}</td>
                    <td>
                      <h5>{data.param.key}</h5>
                    </td>
                    <td><h5>{data.param.value}</h5></td>
                    <td>
                      <span className="badge badge-success bg-success text-white">
                        {data.alertType}
                      </span>
                    </td>
                    <td>
                      <Link to="#" className="btn btn-outline-secondary mr-1" onClick={() => handleViewClicked(data._id)}>
                        <i className="icon-magnifier" title="Mark as viewed"></i>
                      </Link>
                    </td>
                    </>
                    )}
                  </tr>
                      )
                      })}
                </tbody>
                }
              </table>
              {/*
              <ul className="body pagination pagination-primary">
                      <li className="page-item">
                        <Link to="#" className="page-link">Previous</Link>
                      </li>
                      <li className="page-item active">
                        <Link to="#" className="page-link">1</Link>
                      </li>
                      <li className="page-item">
                        <Link to="#" className="page-link">2</Link>
                      </li>
                      <li className="page-item">
                        <Link to="#" className="page-link">3</Link>
                      </li>
                      <li className="page-item">
                        <Link to="#" className="page-link">Next</Link>
                      </li>
              </ul>
              */}
            </div>
          </div>
        </div>
      </div>


          </div>
        </div>
      </div>
    );
}
